import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import { FormattedMessage } from 'react-intl'
import RowLoader from 'components/RowLoader'
import Income from 'components/Income'
import CountUp from 'components/CountUp'
import NoData from 'components/NoData'
import { ResolverPropType } from 'containers/Dashboard/props'
import messages from './messages'
import styles from './DashboardResolvers.scss'

const cells = ['name', 'revenue', 'cases']

const defaultResolvers = [
  {
    name: 'Short Term Rental',
  },
  {
    name: 'Crypto-NFT',
  },
  {
    name: 'E-Commerce',
  },
  {
    name: 'Influencers',
  },
]

class DashboardResolvers extends Component {
  static propTypes = {
    resolvers: PropTypes.arrayOf(ResolverPropType),
  }

  render() {
    const { resolvers = defaultResolvers } = this.props

    return (
      <ul className={styles.resolvers}>
        <li className={cx(styles.item, styles.header)}>
          {cells.map(cell => (
            <span key={cell} className={cx(styles.cell, styles[cell])}>
              <FormattedMessage {...messages.titles[cell]} />
            </span>
          ))}
        </li>
        {!resolvers.length && defaultResolvers.map((resolver, i) => <RowLoader key={i} />)}
        {!!resolvers.length &&
          resolvers.map(resolver => (
            <li key={resolver.name} className={cx(styles.item, styles.content)}>
              {cells.map(cell => (
                <span key={cell} className={cx(styles.cell, styles[cell])}>
                  {this[cell](resolver)}
                </span>
              ))}
            </li>
          ))}
      </ul>
    )
  }

  name(resolver) {
    return <span>{resolver.name}</span>
  }

  revenue(resolver) {
    const { revenue } = resolver

    return revenue ? <Income value={revenue} /> : <NoData />
  }

  cases(resolver) {
    const { cases } = resolver

    return cases ? <CountUp to={cases} /> : <NoData />
  }
}

export default DashboardResolvers
